import styled from "styled-components";
import SbButton from "uiCore/SbButton/SbButton";

// Action button — width matches the large action buttons used elsewhere.
// Color comes from the Ant theme via buttonType="primary"; no Bootstrap/SCSS.
export const ActionButtonStyled = styled(SbButton)`
  && {
    min-width: 200px;
  }
`;
